<template>
    <Modal v-model="visible" @on-ok="ok" @on-cancel="cancel" :loading="modalLoading" closable mask-closable
        :okText="getTranslation('b156')" :cancelText="getTranslation('b182')" :title="title" width="40">
        <WebSocket :url="webSocketUrl" @receive-message="receiveMessage"></WebSocket>
        <Row class="field-line" type="flex">
            <Col flex="2" class="flex-right"><template v-if="mode == 0">{{ getTranslation('k009') }}</template><template
                v-else>{{ getTranslation('k010') }}</template>:</Col>
            <Col flex="3" class="flex-left">&nbsp;{{ getTranslation('b123') }}<Select class="one-field"
                v-model="selLib1From" :filterable="true" :transfer="true" :placeholder="getTranslation('m034')"
                :not-found-text="getTranslation('b038')">
                <Option v-for="item in library" :value="item.id" :key="item.id">{{ item.id }}</Option>
            </Select> </Col>
            <Col flex="1" class="flex-middle">{{ getTranslation('b121') }} → {{ getTranslation('b124') }}</Col>
            <Col flex="3" class="flex-left"><Select class="one-field" v-model="selLib1To" :filterable="true"
                :transfer="true" :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
                <Option v-for="item in library" :value="item.id" :key="item.id">{{ item.id }}</Option>
            </Select></Col>
            <Col flex="1" class="flex-left">{{ getTranslation('b121') }}</Col>
        </Row>
        <Row class="field-line" type="flex">
            <Col flex="2" class="flex-right"><template v-if="mode == 0">{{ getTranslation('k010') }}</template><template
                v-else>{{ getTranslation('k009') }}</template>:</Col>
            <Col flex="3" class="flex-left">&nbsp;{{ getTranslation('b123') }}<Select class="one-field"
                v-model="selLib2From" :filterable="true" :transfer="true" :placeholder="getTranslation('m034')"
                :not-found-text="getTranslation('b038')">
                <Option v-for="item in library" :value="item.id" :key="item.id">{{ item.id }}</Option>
            </Select> </Col>
            <Col flex="1" class="flex-middle">{{ getTranslation('b121') }} → {{ getTranslation('b124') }}</Col>
            <Col flex="3" class="flex-left"><Select class="one-field" v-model="selLib2To" :filterable="true"
                :transfer="true" :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
                <Option v-for="item in library" :value="item.id" :key="item.id">{{ item.id }}</Option>
            </Select></Col>
            <Col flex="1" class="flex-left">{{ getTranslation('b121') }}</Col>
        </Row>
        <LineProgress v-if="exporting" :oneProgress="oneProgress" ></LineProgress>
        <div slot="footer">
            <Row type="flex" class="menu-actions">
                <Col flex="1" class="flex-right">
                <Button type="default" icon="md-close" @click="cancel">{{ getTranslation('b182') }}</Button>&nbsp;
                <Button type="warning" @click="ok" icon="md-refresh" :loading="modalLoading">{{ getTranslation('k024') }}</Button>
                </Col>
            </Row>
        </div>

    </Modal>

</template>
<script>
/* eslint-disable */
import { API_URL } from '@/constants/const.js'
import axios from 'axios';
import { mapGetters } from 'vuex'
import { postJsError } from '@/util/util.js'
import LineProgress from '@/components/LineProgress.vue';
import WebSocket from '@/components/WebSocket.vue';
export default {
    name: 'UserEdit', // 组件名称
    components: {
        LineProgress, WebSocket
    },
    props: {
        propVisible: Boolean,
        mode: String,
        mac: Number,
        id: Number,
        libSize: Number,
    },
    data() {
        return {
            modalLoading: true,
            library: [],
            selLib1From: -1,
            selLib1To: -1,
            selLib2From: -1,
            selLib2To: -1,
            exporting: false,
            oneProgress: {
                processed: 0,
                total: 0,
                status: 'waiting',
            },
        }
    },
    computed: {
        ...mapGetters(['getTranslation']),
        visible: {
            get() { return this.propVisible },
            set(val) { this.$emit('input', val) }
        },
        title() {
            if (this.mode == 0) {
                return this.getTranslation('b153');
            } else {
                return this.getTranslation('b154');
            }
        },
        webSocketUrl() {
            return API_URL['webSocket']+ "?mac=" + this.$route.query.mac;;
        },
    },
    watch: {
        visible(newVal) {
            if (newVal) {
                this.library = this.createLibrary(this.libSize)
                this.selLib1From = 0
                this.selLib1To = 0
                this.selLib2From = 0
                this.selLib2To = 0
                this.exporting = false
                this.modalLoading = false
                this.initSocket();
            }
        }
    },

    methods: {
         initSocket() {            
            const mac = this.mac ?? this.$route.query.mac;
            this.$ws.updateUrl(API_URL["webSocket"] + '?mac=' + mac);
            // Prevent duplicate subscriptions
            this.$ws.unsubscribe?.('progressType', this._boundProgressHandler);
            this._boundProgressHandler = this.progressTypeHandler.bind(this);
            this.$ws.subscribe('progressType', this._boundProgressHandler);
        },
        async ok() {
            this.exporting = true;

            this.modalLoading = true;
            let url = API_URL["programSync"];
            let params = {}
            if (this.mode == 0) {
                params = {
                    mac: this.mac,
                    mode: this.mode,
                    begin0: this.selLib2From,
                    end0: this.selLib2To,
                    begin1: this.selLib1From,
                    end1: this.selLib1To,
                }
            } else {
                params = {
                    mac: this.mac,
                    mode: this.mode,
                    begin0: this.selLib1From,
                    end0: this.selLib1To,
                    begin1: this.selLib2From,
                    end1: this.selLib2To,
                }
            }

            let res = await axios.get(url, {
                params: params,
                timeout: 300000,
            }).catch((err) => {
                postJsError(err)
                this.modalLoading = false;
                this.resetModal();
                this.$Message.error(this.getTranslation('c001'));
            })

            if (res && res.data && res.data.code && res.data.code == 200) {
                this.$Message.success(res.data.msg)
                this.visible = false
            } else if (res && res.data && res.data.code && res.data.msg) {
                this.$Message.error(res.data.msg);
                this.modalLoading = false;
                this.resetModal();
            } else {
                this.modalLoading = false;
                this.resetModal();
            }
            this.exporting = false;

        },

        resetModal() {
            this.$nextTick(() => {
                this.modalLoading = true;
            });
        },
        cancel() {
            this.visible = false;
            this.exporting = false;


        },
        createLibrary(size) {
            let rs = []
            for (var i = 0; i < size; i++) {
                rs.push({ "id": i, "ProgramId": i })
            }
            return rs;
        },
        progressTypeHandler(msgData) {            
            if (msgData && msgData.type === 'syncTask') {
                this.oneProgress = msgData;
                if (!this.exporting) this.exporting = true;
                if (msgData.status === 'done' || msgData.status === 'error') {
                    this.exporting = false;
                }
            }
        },
        receiveMessage(obj) {
            if (obj && obj.kind) {
                switch (obj.kind) {
                case 'progressType':
                    this.progressTypeHandler(obj.data);
                    break;
                default:
                    break;
                }
            }
        }
    },

}
</script>

<style scoped>
@import url("../../../assets/style/list.css");

.field-line {
    margin-bottom: 8px;
}

.desc-field {
    width: 60%;
}

.one-field {
    width: 85%;
}
</style>